import { useContext } from "react";
import { useSearchParams } from "react-router";

import { SheetScopeContext } from "@/contexts/SheetScopeContext";

export function useCurrentCandidacyId(options: { optional: true }): string | null;
export function useCurrentCandidacyId(): string;
// NOTE: This ensures that callers can't use `({ optional: false })`. Use `()` instead.
export function useCurrentCandidacyId(options?: { optional?: boolean }) {
  // This is to allow CandidateSheet to be rendered in Application Review in Dashboard
  const sheetContext = useContext(SheetScopeContext);
  const [searchParams] = useSearchParams();

  const candidacyId = sheetContext?.candidacyId ?? searchParams.get("c");
  if (!candidacyId) {
    if (options?.optional) return null;
    throw new Error("Current candidacy id not found");
  }

  return candidacyId;
}
